export default __webpack_public_path__ + "static/media/playstore.b6177954.svg";